import { jsx as _jsx } from "react/jsx-runtime";
import { Text } from '../typography';
export function CardLabel({ children }) {
    return (_jsx(Text, { type: "s", className: "text-neutral-fg font-medium mb-stack-tight", children: children }));
}
